import React from "react";
import IconComponent from "./IconComponent";
const SpotsTimeline = ({ spotsListRaw, detailHeading, isDarkMode }) => {
  // Filter and sort spots
  const spotsList = spotsListRaw
    .filter((spot) => spot.isEnabled)
    .sort((a, b) => a.sequence - b.sequence);

  return (
    <div className="p-4">
      {/* Heading */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">
          Proposed Itinerary
        </h2>
        <span className="px-3 py-1 text-sm rounded-md bg-gray-200">
          {detailHeading}
        </span>
      </div>

      {/* Timeline List */}
      <div className="space-y-6">
        {spotsList.map((item, index) => (
          <div key={index} className="flex items-start space-x-4 relative">
            {/* Left Section: Icon or Image */}
            <div className="flex flex-col items-center">
              {item.placeId.iconName ? (
                // <div className="w-8 h-8 flex items-center justify-center rounded-full border bg-gray-200 dark:bg-gray-800">
                //   <i className={`text-lg ${item.placeId.iconName}`} />
                // </div>
                <IconComponent iconName={item.placeId.iconName}/>
              ) : (
                <img
                  src={
                    item.placeId.thumbnailImage?.trim() || ""
                  }
                  alt={item.placeId.shortName}
                  className="w-12 h-12 rounded-full object-cover"
                />
              )}

              {/* Connecting Line */}
              {index < spotsList.length - 1 && (
                <div className="w-0.5 h-10 bg-gray-400 mt-3" />
              )}
            </div>

            {/* Right Section: Details */}
            <div className="flex-1">
              <h3 className="text-base font-semibold">
                {item.placeId.shortName}
              </h3>
              <p className="text-sm text-gray-600">
                {item.placeId.fullName}
              </p>
              {item.placeId.message && (
                <p className="text-xs text-blue-500">
                  [Info] {item.placeId.message}
                </p>
              )}
            </div>

            {/* Time */}
            <div className="text-xs font-medium text-center w-16">
              {item.placeId.approxVisitTime} mins
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpotsTimeline;
